import _ from "lodash";

export const createLoadingSelector = (actions) => (state) =>
  _(actions).some((action) => _.get(state, `loading.${action}`));
